interface ButtonProp {
    text: string,
    onClick: () => void,
    active?: boolean,
    className?: string,
    serviceId?: string
}

const Button = ({ text, onClick, active = false, className = '', serviceId }: ButtonProp) => {
  // Determine text color based on serviceId
  const textColor = (active && serviceId === 'fabric') ? 'text-black' : 'text-white';
  
  return (
    <button
      type="button"
      onClick={onClick}
      className={`py-4 px-4 md:px-12 md:py-4 rounded-md font-semibold transition-all ${
        active ? `${className} ${textColor}` : "bg-white text-black"
      }`}
    >
      <p>{text}</p>
    </button>
  );
};

export default Button